import { Box } from '@/components/Box/Box';
import {
  UserDetailsCard,
  UserDetailsRow,
  UserDetailsRowTitle,
  UserDetailsRowValue,
} from '@/bundle/_Opco/shared/styles';
import { IconButton } from '@/components/IconButton/IconButton';
import EditIcon from '@/images/EditIcon.svg?react';
import { useState } from 'react';
import { UserRole } from '@/bundle/_Opco/shared/UserRole/UserRole';
import { ORGANIZATION_USER_ROLE_ICON_MAP } from '@/bundle/_Opco/ui/OrganizationDetails/const/const';
import { formatPhone } from '@/helpers/formatHelpers';
import { Drawer } from '@/components/Drawer/Drawer';
import { EditMobilePhoneForm } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/ui/EditMobilePhoneForm';
import { EditAdminRoleForm } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/ui/EditAdminRoleForm';
import { InternalOrganizationUserType } from '../../types/types';
import { ORGANIZATION_USER_ROLE_LABEL_MAP } from '@/const/user';
import { AdminAccountDetailsStatusActions } from './AdminAccountDetailsStatusActions';
import { isBlockedOrganizationUser, isInvitedOrganizationUser } from '@/helpers/organizationHelpers';

type AdminAccountDetailsType = {
  user: InternalOrganizationUserType;
  onRefetchUser: () => void;
  isOwnAccount: boolean;
};

export const AdminAccountDetails = ({ user, onRefetchUser, isOwnAccount }: AdminAccountDetailsType) => {
  const [isEditMobilePhoneOpen, setIsEditMobilePhoneOpen] = useState(false);
  const [isEditRoleOpen, setIsEditRoleOpen] = useState(false);

  const openEditMobilePhone = () => setIsEditMobilePhoneOpen(true);
  const closeEditMobilePhone = () => setIsEditMobilePhoneOpen(false);

  const openEditRole = () => setIsEditRoleOpen(true);
  const closeEditRole = () => setIsEditRoleOpen(false);

  const { email, mobile_phone, status, role } = user;
  const formattedMobilePhone = formatPhone(mobile_phone);
  const formattedRole = ORGANIZATION_USER_ROLE_LABEL_MAP[role];
  const icon = ORGANIZATION_USER_ROLE_ICON_MAP[user?.role];
  const isInvited = isInvitedOrganizationUser(status);
  const isBlocked = isBlockedOrganizationUser(status);

  return (
    <Box width='100%'>
      <UserDetailsCard>
        <UserDetailsRow>
          <UserDetailsRowTitle>Email Address</UserDetailsRowTitle>
          <UserDetailsRowValue>{email}</UserDetailsRowValue>
        </UserDetailsRow>
        <UserDetailsRow>
          <Box flexDirection='row' justifyContent='space-between'>
            <Box>
              <UserDetailsRowTitle>Mobile Phone Number</UserDetailsRowTitle>
              <UserDetailsRowValue>{formattedMobilePhone}</UserDetailsRowValue>
            </Box>
            {isInvited && (
              <IconButton onClick={openEditMobilePhone} marginLeft='12px'>
                <EditIcon />
              </IconButton>
            )}
          </Box>
        </UserDetailsRow>
        <UserDetailsRow>
          <Box flexDirection='row' justifyContent='space-between'>
            <Box>
              <UserDetailsRowTitle>Role</UserDetailsRowTitle>
              <UserRole role={formattedRole} icon={icon}></UserRole>
            </Box>
            {!isBlocked && !isOwnAccount && (
              <IconButton onClick={openEditRole} marginLeft='12px'>
                <EditIcon />
              </IconButton>
            )}
          </Box>
        </UserDetailsRow>
        <AdminAccountDetailsStatusActions user={user} onRefetchUser={onRefetchUser} isOwnAccount={isOwnAccount} />
      </UserDetailsCard>
      <Drawer
        header='Edit Mobile Phone Number'
        subHeader='Please edit mobile phone number.'
        isOpen={isEditMobilePhoneOpen}
        onClose={closeEditMobilePhone}
      >
        <EditMobilePhoneForm mobilePhone={mobile_phone} onClose={closeEditMobilePhone} onRefetchUser={onRefetchUser} />
      </Drawer>

      <Drawer header='Edit Role' subHeader='Please edit user role.' isOpen={isEditRoleOpen} onClose={closeEditRole}>
        <EditAdminRoleForm role={role} onClose={closeEditRole} onSuccess={onRefetchUser} />
      </Drawer>
    </Box>
  );
};
